/**
 * Sidebar Icon
 *
 */

import type { SVGProps } from 'react'

export default function story(props: SVGProps<SVGSVGElement> = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.20989 4.62421H2.73663C1.77752 4.62421 1 5.38482 1 6.32308V18.8381C1 19.7764 1.77752 20.537 2.73663 20.537H6.20989C7.169 20.537 7.94652 19.7764 7.94652 18.8381V6.32308C7.94652 5.38482 7.169 4.62421 6.20989 4.62421Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1564 1H9.68316C8.72405 1 7.94653 1.76061 7.94653 2.69888V18.8382C7.94653 19.7765 8.72405 20.5371 9.68316 20.5371H13.1564C14.1155 20.5371 14.893 19.7765 14.893 18.8382V2.69888C14.893 1.76061 14.1155 1 13.1564 1Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3324 2.64023L16.6138 2.88451C15.6647 3.01942 15.0071 3.88149 15.145 4.81001L17.2674 19.1004C17.4053 20.0289 18.2866 20.6723 19.2357 20.5373L20.9543 20.2931C21.9035 20.1582 22.5611 19.2961 22.4232 18.3676L20.3007 4.07718C20.1628 3.14867 19.2816 2.50532 18.3324 2.64023Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
